import React from 'react';

import { useProject } from '@hooks/API/Project/UseProject';

import { Loading } from '@components/Gui/Loading';
import NwDrawer from '@components/Gui/NwDrawer';

import SendProjectDrawerContent from './SendProjectDrawerContent';
import { SendProjectDrawerProvider } from './SendProjectDrawerContext';

const SendProjectDrawerFromEvent = ({ event, eventType, onClose }) => {
    const { data: project, isFetching } = useProject(event.Project.ID);
    // Non booking events do not always carry TypeName: the caller passes it explicitly
    const EventType = eventType || event.TypeName;

    return (
        <SendProjectDrawerProvider>
            <NwDrawer
                title="Send schedule by e-mail"
                onClose={onClose}
                width="80vw"
                maxWidth="960px"
                padding="0"
                id="send-project-drawer"
            >
                {!project || isFetching ? (
                    <Loading textBlack />
                ) : (
                    <SendProjectDrawerContent
                        currentProject={project}
                        //ModelID={ModelID}
                        EventID={event.ID}
                        EventType={EventType}
                        onClose={onClose}
                    />
                )}
            </NwDrawer>
        </SendProjectDrawerProvider>
    );
};

export default SendProjectDrawerFromEvent;
